import { ConvertibleUnit, FormatOptions, Unit } from '@dynatrace-sdk/units';

import { ChartUnit } from '../types/chart-unit.js';
import { Formatter, isFormatterOptions } from '../types/formatter.js';

export const computeRangeLegendFormatter = (
  formatter: Formatter | FormatOptions<Unit, ConvertibleUnit>,
  unit: ChartUnit,
): Formatter | FormatOptions<Unit, ConvertibleUnit> => {
  if (!isFormatterOptions(formatter)) {
    return (value: number) => formatter(value, unit);
  }

  return formatter;
};
